import React from "react";
import "./styles.css";

import DisplayStatus from "../../molecules/DisplayStatus";

const AttributesDisplay = (props) => {
    const {
        strength,
        agility,
        intelligence,
        spirit,
        constitution,
        strengthStatus,
        agilityStatus,
        intelligenceStatus,
        spiritStatus,
        constitutionStatus,
        handleChange,
    } = props;

    return (
        <div className="display-container">
            <DisplayStatus
                id={"strength"}
                title={"Força"}
                value={strength}
                status={strengthStatus}
                handleChange={handleChange}
            />
            <DisplayStatus
                id={"agility"}
                title={"Agilidade"}
                value={agility}
                status={agilityStatus}
                handleChange={handleChange}
            />
            <DisplayStatus
                id={"intelligence"}
                title={"Inteligência"}
                value={intelligence}
                status={intelligenceStatus}
                handleChange={handleChange}
            />
            <DisplayStatus
                id={"spirit"}
                title={"Sorte"}
                value={spirit}
                status={spiritStatus}
                handleChange={handleChange}
            />
            <DisplayStatus
                id={"constitution"}
                title={"Constituição"}
                value={constitution}
                status={constitutionStatus}
                handleChange={handleChange}
            />
        </div>
    );
};

export default AttributesDisplay;
